export default __webpack_public_path__ + "static/media/team29.376ebd9b.JPG";